// PRC EDITED: color swatches on product cards (estimate 4093671, line 2).
// Hovering or focusing a swatch (snippets/prc-card-swatches.liquid) shows that color's image on the card.
(() => {
  function showSwatchImage(event) {
    const swatch = event.target.closest?.('[data-prc-card-image]');
    if (!swatch) return;

    const image = swatch.closest('.card-wrapper')?.querySelector('.card__media img');
    if (!image || image.dataset.prcCurrent === swatch.dataset.prcCardImage) return;

    // Keep the secondary hover image from covering the chosen color.
    image.closest('.media')?.classList.add('prc-card-swatches--active');
    image.removeAttribute('srcset');
    image.src = swatch.dataset.prcCardImage;
    image.dataset.prcCurrent = swatch.dataset.prcCardImage;
  }

  document.addEventListener('mouseover', showSwatchImage);
  document.addEventListener('focusin', showSwatchImage);
})();
